import { SubscriptionsPaymentRecurringStatusChoices } from "@repo/graphql/gql/graphql";

/**
 * Whether a subscription still has a working payment method on file.
 *
 * Mirrors the backend's `PaymentRecurringQuerySet.valid()`: RETRYING means one
 * charge failed and the provider is still retrying, not that the card is gone,
 * so asking the customer for a card again mid-dunning would be wrong.
 *
 * This replaced a check against a single `AUTHORIZED` status, which was
 * MercadoPago's own vocabulary and no longer exists now that the status field
 * is provider-agnostic.
 */
export const hasValidSubscriptionPayment = (
  status: SubscriptionsPaymentRecurringStatusChoices | null | undefined,
): boolean =>
  status === SubscriptionsPaymentRecurringStatusChoices.Active ||
  status === SubscriptionsPaymentRecurringStatusChoices.Retrying;
